module.exports = __webpack_public_path__ + "img/cover-promotion-bg.979b4ead.jpg";